import axios from "axios";
import router from "../router"

//1.引入vue
import Vue from 'vue';
//2.新创建一个vue实例
let v = new Vue();

// 创建两个不同的axios实例
const healthAxios = axios.create({
  // baseURL: 'https://health.mvectortech.com/api',
  baseURL: 'https://health.mvector.cn',//生产
  timeout: 30000
});

const pillAxios = axios.create({
  // baseURL: 'https://pill.mvectortech.com/api',
  baseURL: 'https://api.mvector.cn/api',//生产
  timeout: 30000
});

const integratorAxios = axios.create({
  // baseURL: 'https://integrator.mvectortech.com',
  baseURL: 'https://integrator.fanfanmagic.com',//生产
  timeout: 30000
});

const magicAxios = axios.create({
  // baseURL: 'https://fanfanmagic.mvectortech.com',
  baseURL: 'https://fanfanmagic.com',//生产
  timeout: 30000
});

// health.mvectortech.com 的请求拦截器
healthAxios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('hToken')
    if (config.method == "post") {
      config.data = config.data;
      if (token) {
        //config.data.token = token
      }
      config.headers = {
        "Content-Type": "application/json",
        token: token
      };
    } else if (config.method == "get") {
      config.headers = {
        "Content-Type": "application/json",
        token: token
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// pill.mvectortech.com 的请求拦截器
pillAxios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token') || 'f08b6b63-613d-4fec-850d-bcad577b6f3e';
    if (config.method == "post") {
      config.data = config.data;
      if (token) {
        //config.data.token = token
      }
      config.headers = {
        "Content-Type": "application/json",
        token: token
      };
    } else if (config.method == "get") {
      config.headers = {
        "Content-Type": "application/json",
        token: token
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// integrator.mvectortech.com 的请求拦截器
integratorAxios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('stoken')
    if (config.method == "post") {
      config.data = config.data;
      if (token) {
        //config.data.token = token
      }
      config.headers = {
        "Content-Type": "application/json",
        'admintoken': token
      };
    } else if (config.method == "get") {
      config.headers = {
        "Content-Type": "application/json",
        'admintoken': token
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 饭饭魔法
magicAxios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('mtoken')
    if (config.method == "post") {
      config.data = config.data;
      if (token) {
        //config.data.token = token
      }
      config.headers = {
        "Content-Type": "application/json",
        'token': token
      };
    } else if (config.method == "get") {
      config.headers = {
        "Content-Type": "application/json",
        'token': token
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// health.mvectortech.com 的响应拦截器
healthAxios.interceptors.response.use(
  response => {
    if (response.data.errCode == 2) {
      localStorage.removeItem('hToken')
      router.push({
        path: "/healthLogin",
        querry: { redirect: router.currentRoute.fullPath }
      });
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

// pill.mvectortech.com 的响应拦截器
pillAxios.interceptors.response.use(
  response => {
    if (response.data.errCode == 2) {
      router.push({
        path: "/login",
        querry: { redirect: router.currentRoute.fullPath }
      });
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);
// integrator.mvectortech.com 的响应拦截器
integratorAxios.interceptors.response.use(
  response => {
    if (response.data.code == 1) {
      localStorage.removeItem('stoken')
      router.push({ path: "/starLogin" ,querry: { redirect: router.currentRoute.fullPath }});
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

magicAxios.interceptors.response.use(
  response => {
    if (response.data.code == 1000 || response.data.code == 4 ) {
      localStorage.removeItem('mtoken')
      router.push({ path: "/magicLogin" ,querry: { redirect: router.currentRoute.fullPath }});
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 根据URL判断使用哪个axios实例
 */
function getAxiosInstance(type) {
  if (type == 'health') {
    return healthAxios;
  }else if(type == 'star'){
    return integratorAxios;
  }else if(type == 'magic'){
    return magicAxios
  }else {
    console.log('使用 pill axios 实例');
    return pillAxios;
  }
}

/**
 * 统一的GET请求方法
 */
export function unifiedGet(type,url, params = {}) {
  const axiosInstance = getAxiosInstance(type);
  const finalUrl = url;

  return new Promise((resolve, reject) => {
    axiosInstance({
      url: finalUrl,
      method: "GET",
      params: params
    })
      .then(res => {
        if (res.data.code == 1000 || res.data.code == 1) {
          v.$message.error(res.data.msg)
          // this.$router.push({ path: "/login" });
          return;
        }
        if(res.data.code == 4){
          v.$message.error(res.data.msg)
        }
        resolve(res.data);
      })
      .catch(err => {
        if (err.response && err.response.status === 500) {
          this.utils.ToastSuccess("网络不可用，请检查你的网络设置");
        }
        reject(err);
      });
  });
}
/**
 * 统一的POST请求方法
 */
export function unifiedPost(type,url, data = {}) {
  const axiosInstance = getAxiosInstance(type);
  const finalUrl = url;

  return new Promise((resolve, reject) => {
    axiosInstance({
      url: finalUrl,
      method: "POST",
      data: data
    })
      .then(res => {
        console.log(res,'res');
        if (res.data.code == 1000  || res.data.code == 1) {
          v.$message.error(res.data.msg)
          // this.$router.push({ path: "/login" });
          return;
        }
        if(res.data.code == 4){
          v.$message.error(res.data.msg)
        }
        resolve(res);
      })
      .catch(err => {
        if (err.response && err.response.status === 500) {
          // this.utils.ToastSuccess("网络不可用，请检查你的网络设置");
        }
        reject(err);
      });
  });
}

// 导出axios实例供其他地方使用
export { healthAxios, pillAxios , integratorAxios,magicAxios};



// WEBPACK FOOTER //
// ./src/utils/requestManager.js